// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(activeStatusString) {
  switch (activeStatusString) {
    case "active" :
        return /* Active */0;
    case "inactive" :
        return /* Inactive */1;
    case "pending_onboarding" :
        return /* Pending_Onboarding */2;
    default:
      return ErrorUtils$Catalyst.raiseError("DriverActiveStatus.re", "Invalid 'activeStatus' ", activeStatusString);
  }
}

function toString(activeStatusString) {
  switch (activeStatusString) {
    case /* Active */0 :
        return "active";
    case /* Inactive */1 :
        return "inactive";
    case /* Pending_Onboarding */2 :
        return "pending_onboarding";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
